<div class="wizzard-header">
    <div class="wizzard-header__inner">
        <shared-header class="wizzard-header__hd" [postContent]="postContent" [preContent]="preContent" type="4"
            [right]="right" [marginTop]="marginTop" [marginBottom]="marginBottom" [paddingTop]="paddingTop"
            [paddingBottom]="paddingBottom" [left]="left" [counter]="counter">
            <ng-content></ng-content>
        </shared-header>
    </div>
</div>